<template>
  <footer>
    <div class="block">
      <div class="journal">
        <a class="journal-icon" href="https://vkusno.namtam.ru" target="_blank">
          <IconBook />
        </a>
        <div class="journal-item">
          <a
            class="journal-title"
            href="https://vkusno.namtam.ru"
            target="_blank"
            >Намтам Вкусно</a
          >
          <a
            class="journal-subtitle"
            href="https://vkusno.namtam.ru"
            target="_blank"
            >Журнал о еде и ресторанах</a
          >
        </div>
      </div>
    </div>
    <div class="block">
      <div class="links">
        <a href="https://vkusno.namtam.ru/we-are-namtam" target="_blank"
          >О нас</a
        >
        <a href="https://vkusno.namtam.ru/docs/confident" target="_blank"
          >Политика конфиденциальности</a
        >
        <a href="https://vkusno.namtam.ru/docs/lagreement" target="_blank"
          >Лицензионное соглашение</a
        >
        <a href="https://b2b.namtam.ru" target="_blank">Для ресторанов</a>
      </div>
    </div>
    <div class="block">
      <div class="links">
        <a href="https://vkusno.namtam.ru/docs/oferta" target="_blank"
          >Оферта</a
        >
        <a href="https://vkusno.namtam.ru/faq" target="_blank">FAQ</a>
        <a href="https://jivo.chat/2EfX44qOaO" target="_blank">Поддержка</a>
      </div>
    </div>
    <div class="block">
      <div class="social-links">
        <div class="social-links-item">
          <a
            href="https://t.me/namtam_ekb"
            target="_blank"
            class="social-links-icon"
          >
            <IconTG />
          </a>
          <a
            href="https://t.me/namtam_ekb"
            target="_blank"
            class="social-links-title"
          >
            Telegram
          </a>
        </div>
        <div class="social-links-item">
          <a
            href="https://vk.com/club228183420?utm_source=b2c&utm_medium=web&utm_campaign=podval"
            target="_blank"
            class="social-links-icon"
          >
            <IconVK />
          </a>
          <a
            href="https://vk.com/club228183420?utm_source=b2c&utm_medium=web&utm_campaign=podval"
            target="_blank"
            class="social-links-title"
          >
            Вконтакте
          </a>
        </div>
      </div>
    </div>
    <div class="block"></div>
  </footer>
</template>

<script>
import IconBook from "@/components/icons/IconBook.vue";
import IconTG from "@/components/icons/IconTG.vue";
import IconVK from "@/components/icons/IconVK.vue";

export default {
  name: "Footer",
  components: { IconVK, IconTG, IconBook },
};
</script>

<style scoped lang="scss">
footer {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 48px;
  width: 100%;
  padding: 32px 24px;
  background: #fff;
  z-index: 2147483646;

  @include l-laptop {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 0 20px;

    .block:last-child {
      margin-top: auto;
    }
  }

  @include mobile {
    display: none;
  }
}

.journal {
  display: flex;
  align-items: center;
  gap: 16px;

  .journal-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 16px;
    background-color: #fef6e8;
  }
  .journal-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .journal-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  }
  .journal-subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #858585;
  }
}

.links {
  display: flex;
  flex-direction: column;
  gap: 12px;

  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.social-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
}
.social-links-item {
  display: flex;
  align-items: center;
  gap: 12px;
}
.social-links-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #222222;
}

.social-links-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;

  .contact-phone {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  }

  .contact-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #858585;
  }
}
</style>
